import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-21',
  templateUrl: './21.component.html',
})
export class VbList21Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
